import { Months } from '../Months';
const {
  JANUARY,
  DECEMBER
} = Months;
function getNextMonth(_ref) {
  let [month, year] = _ref;
  if (month === DECEMBER + 1) {
    return [JANUARY + 1, year + 1];
  }
  return [month + 1, year];
}
export default getNextMonth;
//# sourceMappingURL=getNextMonth.js.map